import { render, staticRenderFns } from "./shanghai.vue?vue&type=template&id=7f9c23bc&"
import script from "./shanghai.vue?vue&type=script&lang=js&"
export * from "./shanghai.vue?vue&type=script&lang=js&"
import style0 from "./shanghai.vue?vue&type=style&index=0&id=7f9c23bc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports